<app-breadcrumb></app-breadcrumb>
<mat-card class="cardWithShadow">
    <mat-card-content class="p-20 cardWithShadow">
        <div class="row justify-content-between gap-16">
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100 hide-hint ">
                    <input matInput
                        placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }} {{ 'ENTITY.CLINICALITEM' | translate }}"
                        [formControl]="searchItem" />
                    <mat-icon matSuffix>
                        <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
                    </mat-icon>
                </mat-form-field>
            </div>
            <div class="col-lg-4 d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" class="cardWithShadow" (click)="onItemAdd()">
                    <mat-icon>add</mat-icon>
                    {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.CLINICALITEM' | translate }}
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<mat-card class="cardWithShadow m-0">
    <mat-card-content class="p-0">
        <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="dataSource" class="w-100">

                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'ENTITY.CATEGORY' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 ellipsis-text">

                        {{getCategoryName(element.categoryId)}}

                    </td>
                </ng-container>

                <ng-container matColumnDef="subcategory">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ENTITY.SUBCATEGORY' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 ellipsis-text">
                        {{getSubCategoryName(element.subCategoryId)||'-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.DESCRIPTION_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 ellipsis-text">{{ element.description }}</td>
                </ng-container>

                <ng-container matColumnDef="additionalInfo">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ADDITIONALINFO' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 ellipsis-text">{{ element.additionalInfo||'-'
                        }}</td>
                </ng-container>

                <ng-container matColumnDef="isSince">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ISSINCE_LABEL' | translate }}
                    </th>

                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        <mat-icon class="check-checkbox-icon text-primary">
                            {{ element.isSince ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                    </td>

                </ng-container>



                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ACTION_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="action-link">
                        <a class="m-r-10 cursor-pointer" (click)="onItemUpdate(element)">
                            <i-tabler name="edit" class="icon-18"></i-tabler>
                        </a>
                        <a class="m-r-10 cursor-pointer" (click)="onDeleteClinicalItem(element.id)">
                            <i-tabler name="trash" class="icon-18"></i-tabler>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <div *ngIf="dataSource.data.length === 0" class="no-data-message">
                <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
            </div>
            <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
                [length]="pagination.rowCount" [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions"
                [showFirstLastButtons]="true" [pageIndex]="pagination.currentPage">

            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>